import { MARKETPLACE_CDN_URL, ASSETS_2022_CDN } from 'util/constants';
import { CDN } from '@src/components/scene/assets/baseUrl';

const blankSceneTemplateURL = `${CDN}/studioAssets/imageAssets/noSceneT.jpg`;

export const zepetoScenes = [
  {
    id: '',
    baseModelURL: '',
    thumbnail: blankSceneTemplateURL,
  },
  {
    id: '',
    baseModelURL: `${ASSETS_2022_CDN}/studioAssets/openAuditorium/`,
    thumbnail: `${ASSETS_2022_CDN}/studioAssets/imageAssets/openAuditorium.jpg`,
  },
  {
    id: '',
    baseModelURL: `${MARKETPLACE_CDN_URL}zepeto-scenes/scene/scene_1/`,
    thumbnail: `${MARKETPLACE_CDN_URL}zepeto-scenes/preview/scene_1.jpg`,
  },
  {
    id: '',
    baseModelURL: `${MARKETPLACE_CDN_URL}zepeto-scenes/scene/scene_2/`,
    thumbnail: `${MARKETPLACE_CDN_URL}zepeto-scenes/preview/scene_2.jpg`,
  },
];
